module.exports = __webpack_public_path__ + "static/media/remock.43704d3d.png";